var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#arrowFilter2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrowMask2",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3.25,
    width: 9,
    height: 6,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 3.25h9v6H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.56 4.792a1 1 0 00-1.779 0L7 8.25h5.34l-1.78-3.458z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.56 4.792a1 1 0 00-1.779 0L7 8.25h5.34l-1.78-3.458z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.781 4.792l-.889-.458.89.458zm1.778 0l.89-.458-.89.458zM7 8.25l-.889-.458L5.36 9.25H7v-1zm5.34 0v1h1.64l-.75-1.458-.89.458zm-2.67-3l1.778-.916c-.744-1.445-2.811-1.445-3.556 0l1.778.916zM7.89 8.708L9.67 5.25l-1.778-.916-1.781 3.458 1.778.916zM7 9.25h5.34v-2H7v2zm2.67-4l1.782 3.458 1.778-.916-1.782-3.458-1.778.916z",
    fill: "#E8E8E8",
    mask: "url(#arrowMask2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "arrowFilter2",
    x: -2.64,
    y: -4.75,
    width: 24.621,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1dc05995a9d2664030dfbabd121af4c0.svg";
export { ForwardRef as ReactComponent };